export const TranslateDirection = {
	X: 'X',
	Y: 'Y'
};
